export default "__VITE_ASSET__OUHYex8K__"